import styled from "styled-components";
import { A } from "styles/elements";

export const LinkButton = styled(A)`
  margin: 0 15px;
  font-size: 10pt;

  @media (max-width: 1000px) {
    font-size: 9.5pt;
    padding: 4px 6px;
  }
`;
